export default "__VITE_ASSET__DoUZfyKM__"